import styled from 'styled-components'

const TitleContainer = styled.div`
  align-items: center;
  display: flex;
`

export default TitleContainer
